import * as React from "react";
import Modal from "../Modal";
import DatePickerInput from "../Datepicker";
import Selectfield from "../Merchant/Selectfield";
import Textarea from "../Textarea";
import Button from "../Button";
import { Colors } from "../../config/Constants";
import styled from "styled-components";
import Textfield from "../Merchant/Textfield";

interface Props {
  data: any;
  onPricingFormChange: (event: any) => void;
  onPriceFormSubmit: () => void;
  errors: any;
  onToggleModalState: (val: any) => void;
  products: any;
  fetchLoader: any;
  addLoader: any;
  isEdit: any;
}

const ManagePriceModal = ({
  onToggleModalState,
  data,
  onPricingFormChange,
  onPriceFormSubmit,
  errors,
  products,
  fetchLoader,
  addLoader,
  isEdit,
}: Props) => {
  return (
    <Modal
      variant={"none"}
      setOpenOrClose={(status) => onToggleModalState(status)}
      width={"300px"}
    >
      <BlockDateHeader>
        <div></div>
        <HeaderTitle>Manage Special Pricing</HeaderTitle>
        <Close
          src={require("../../assets/images/ei_close.png")}
          alt="close"
          onClick={() => onToggleModalState(false)}
        />
      </BlockDateHeader>
      <div
        style={{
          padding: "1.5rem",
          display: "flex",
          flexDirection: "column",
          gap: "1rem",
        }}
      >
        <div style={{ flex: 1 }}>
          <DatePickerInput
            disabled={isEdit}
            required={true}
            // minDate={new Date()}
            label="Date"
            width="236px"
            value={data?.date}
            onChange={(e) =>
              onPricingFormChange({ target: { value: e, name: "date" } })
            }
            error={errors?.["date"]}
          />
        </div>
        <div style={{ flex: 1 }}>
          <Selectfield
            disabled={isEdit}
            data={[{ label: "Select Product", value: "" }, ...products]}
            name="productId"
            label="Select Product"
            required
            value={data?.productId}
            onChange={(e) => onPricingFormChange(e)}
            helperText={errors?.productId || errors?.productCode}
          />
        </div>
        <div style={{ flex: 1 }}>
          <Textfield
            label="Price"
            placeholder={"Enter Price"}
            // variant={"none"}
            onChange={onPricingFormChange}
            value={data.price}
            name="price"
            helperText={errors?.price}
            // helperText={errors?.price}
          />
        </div>
        <Button
          color={Colors.red}
          label={isEdit ? "Update" : "Submit"}
          variant="filled"
          onClick={onPriceFormSubmit}
          disabled={fetchLoader || addLoader}
        />
      </div>
    </Modal>
  );
};

const BlockDateHeader = styled.div`
  display: flex;
  justify-content: space-between;
  padding: 1rem 1rem;
  padding-bottom: 0.5rem;
`;
const HeaderTitle = styled.div`
  font-family: "Poppins-Medium";
  font-size: 1rem;
  color: ${Colors.mineShaft};
`;
const Close = styled.img`
  //   transform: translate(4.375rem, -0.25rem);
  cursor: pointer;
`;

export default ManagePriceModal;
